import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimeout: number;
    let hideTimeout: number;
    const cycle = () => {
      showTimeout = window.setTimeout(() => {
        setVisible(true);
        hideTimeout = window.setTimeout(() => {
          setVisible(false);
          setIndex(prev => (prev + 1) % purchaseNotifications.length);
        }, 5000);
      }, 4500);
    };
    cycle();
    return () => {
      window.clearTimeout(showTimeout);
      window.clearTimeout(hideTimeout);
    };
  }, [index, dismissed]);
  if (dismissed) return null;
  const item = purchaseNotifications[index];
  return <div className={['fixed left-3 right-3 top-3 z-50 transition-[opacity,transform] duration-200 ease-out sm:left-4 sm:right-auto sm:top-auto sm:bottom-24 sm:w-[330px]', visible ? 'translate-y-0 opacity-100' : 'pointer-events-none -translate-y-3 opacity-0'].join(' ')} aria-live="polite" data-id="element-253" data-mp="1gxvwaw4lzx7u">
      <div className="flex items-start gap-3 rounded-2xl border border-brand-100 bg-white p-3.5 shadow-[0_16px_40px_-16px_rgba(33,10,56,0.5)]" data-id="element-254" data-mp="1fxmzrsc7u2fw">
        <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gogreen-500/10" data-id="element-255" data-mp="n6bqpskcxfle">
          <CheckCircle2Icon className="h-5 w-5 text-gogreen-600" aria-hidden="true" data-id="element-256" data-mp="i9bt861kpl5w" />
        </span>
        <div className="min-w-0 flex-1" data-id="element-257" data-mp="x62ihmhj9ghs">
          <p className="text-[13.5px] font-bold leading-snug text-ink" data-id="element-258" data-mp="x2yasf4v02md">
            {item.name} just got the Blueprint
          </p>
          <p className="mt-0.5 text-[12px] font-medium text-brand-800/70" data-id="element-259" data-mp="28jok474kxak7">
            {item.place} · a few seconds ago
          </p>
        </div>
        <button type="button" onClick={() => setDismissed(true)} className="-mr-1 -mt-1 rounded-lg p-1 text-brand-800/40 transition-colors duration-150 ease-out hover:text-brand-800" aria-label="Dismiss notification" data-id="element-260" data-mp="23l3ettah00ow">
          <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-261" data-mp="2knsg0v5szwnq" />
        </button>
      </div>
    </div>;
}